// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3IZVh","upload":"Small_upload__2Wuek","imageWrap":"Small_imageWrap__EfBsm","removeBtn":"Small_removeBtn__3ulJ2"};